import React from "react";
import { useNavigate } from "react-router-dom";

export default function Disclaimer() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white p-6 flex flex-col">
      {/* Content Section */}
      <div className="flex-grow flex items-center justify-center">
        <div className="max-w-4xl w-full text-white rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-white mb-6">Disclaimer</h1>

          <p className="text-white leading-relaxed mb-6">
            This Disclaimer explanation applies to{" "}
            <span className="font-semibold">www.aicahealth.com</span> website
            and mobile apps and represents information accumulation and usage
            for the reasons for this statement, unless generally noted. This
            disclaimer needs to underscore completely that{" "}
            <span className="font-semibold">AICAHealth</span>, owned by{" "}
            <span className="font-semibold">AICA Healthtech Pvt Ltd</span>, does
            not provide clinical diagnosis or treatment. Integrated support is
            meant to bolster the doctor-patient, caregiver-patient relationship
            and not supplant it.
          </p>

          <p className="text-white leading-relaxed mb-6">
            All rights reserved. The{" "}
            <span className="font-semibold">AICA Health logo</span> is a
            trademark of AICA Healthtech Pvt Ltd and may not be utilized without
            written consent. AICA Health does not supplant the essential
            consideration of doctors and does not guarantee that a prescription
            will be provided. AICA Health operations are subject to state
            regulation and may not be available in certain states.
          </p>

          <p className="text-white leading-relaxed mb-6">
            AICA Health does not endorse DEA-controlled substances,
            non-therapeutic drugs, and certain medications that may be harmful
            due to their potential for misuse. AICA Health reserves the right to
            deny services if there is intent for potential misuse.
          </p>

          {/* Subscribe Section */}
          <div className="mt-10 border-t border-white pt-6">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Subscribe for Health Benefits
            </h2>
            <p className="text-white mb-6">
              Get access to exclusive health plans and benefits. We also offer
              great discounts for annual subscriptions.
            </p>
            {/* Uncomment when payment route is ready */}
            {/* <button
              onClick={() => navigate("/payment")}
              className="bg-teal-600 text-white px-6 py-3 rounded-lg shadow hover:bg-teal-700 transition"
            >
              Subscribe
            </button> */}
          </div>
        </div>
      </div>

      {/* Back Button Bottom */}
      <div className="flex justify-center mt-6">
        <button
          onClick={() => navigate("/")}
          className="bg-white text-teal-600 px-6 py-2 rounded-full shadow hover:bg-gray-100 transition"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
